<template>
    <div class="vuedetail">
        <Swipe class="my-swipe" indicator-color="white">
            <Swipe-item v-for="item in detail.imgList" :key="item.seq">
                <img :src="item.url" />
            </Swipe-item>
        </Swipe>
        <div class="my-body">
            <div class="my-header">
                <div>
                    <div>{{detail.name}}</div>
                    <div><span>{{detail.typeName}}</span></div>
                </div>
                <div>
                    <a :href="'tel:'+detail.phone">
                        <img src="@/assets/cell.png" alt="">
                        <span>电话</span>
                    </a>
                    
                </div>
            </div>
            <div class="my-cell">
                <div class="label">场馆地址：</div>
                <div class="value">
                    <div>{{detail.address.address}}</div>
                    <div>{{detail.address.city}}{{detail.address.region}}</div>
                </div>
            </div>
        </div>
        <div class="hr"></div>
        <div class="my-ht">
            <div class="ht-title">
                <img src="@/assets/notice.png" alt="">
                <div>场馆简介</div>
            </div>
            <div class="rule" v-html="detail.note"></div>
        </div>
    </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import { getDetail } from "@/libs/api";

export default {
    components: {Swipe, SwipeItem},
    data() {
        return {
            detail: {}
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            getDetail({id:this.$route.params.id}).then((res)=>{
                res.imgList.forEach(item=>{
                    if(item.url.indexOf('/v3/') === -1) {
                        item.url = item.url.replace('https://changning.movecloud.cn/','https://changning.movecloud.cn/v3/')
                    }
                })
                
                this.detail = res
            })
        }
    }
}
</script>

<style lang="less" scoped>
.vuedetail{
    .my-swipe{
        width: 100%;
        height: 187.5px;
        .van-swipe-item{
            text-align: center;
            img{
                width: auto;
                height: 187.5px;
            }
        }
        
    }
    .my-body{
        box-sizing: border-box;
        padding: 13.5px 16px;
        .my-header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 15px;
            >div:first-child{
                >div:first-child{
                    font-size: 18px;
                    color: rgba(0,0,0,0.85);
                    font-weight: 600;
                    padding-bottom: 8px;
                }
                >div:nth-child(2){
                    span{
                        padding: 2.5px 5px;
                        background: #E7F4FF;
                        border-radius: 1px;
                        font-size: 10px;
                        color: #5191C1;
                        font-weight: 400;
                    }
                }
            }
            >div:nth-child(2){
                a{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: 10px;
                    color: rgba(0,0,0,0.45);
                }                      
                font-weight: 400;
                position: relative;
                box-sizing: border-box;
                padding: 0 10px;
                img{
                    width: 17px;
                    height: 17px;
                    margin-bottom: 3.5px;
                }
            }
            >div:nth-child(2)::before{
                position: absolute;
                width: 1px;
                height: 21px;
                content: ' ';
                left: -5px;
                top: 5px;
                background: #ddd;
            }
        }
        .my-cell{
            display: flex;
            align-items: center;
            padding-top: 12px;
            .label{
                align-self: flex-start;
                font-size: 14px;
                color: rgba(0,0,0,0.45);
                font-weight: 400;
                width: 70px;
            }
            .value{
                
                padding-left: 9.5px;
                >div:first-child{
                    font-size: 14px;
                    color: rgba(0,0,0,0.85);
                    font-weight: 400;
                    padding-bottom: 5px;
                }
                >div:nth-child(2){
                    font-size: 12px;
                    color: rgba(0,0,0,0.45);
                    font-weight: 400;
                }
            }
        }
    }
    .my-ht{
        box-sizing: border-box;
        padding: 13.5px 16px;
        .ht-title{
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000000;
            letter-spacing: 0;
            font-weight: 500;
            padding-bottom: 18px;
            border-bottom: 1px solid rgba(232,232,232,1);
            img{
                width: 17px;
                height: 17px;
                margin-right: 10px;
            }
        }
        .rule{
            padding-top: 10.5px;
            font-size: 14px;
            color: rgba(0,0,0,0.45);
            letter-spacing: 0;
            line-height: 23px;
            font-weight: 400;
        }
    }
}
</style>